
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomModal from '@/components/modal/CustomModal.vue';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import InviteForm from '@/components/customer-project/InviteForm.vue';
import { ApiError } from '@/model/ApiError';
import { InviteInformation, InviteRequest } from '@/model/Project';
import { EventResponse } from '@/model/Event';

@Component({
    components: {
        CustomModal,
        InviteForm,
    },
    methods: {
        ...mapMutations({
            setError: 'customerProjectStorage/setError',
        }),
        ...mapActions({
            invite: 'customerProjectStorage/invite',
            getAllProjectUsers: 'customerProjectStorage/getAllProjectUsers',
        }),
    },
    computed: {
        ...mapGetters({
            inviteError: 'customerProjectStorage/getError',
        }),
    },
})
export default class InviteButton extends mixins(
    ToastMixin,
    FormValidationMixin,
) {
    @Prop() id!: number;

    @Prop() variant!: string;

    @Prop() text!: string;

    @Prop() icon!: string;

    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: '' }) buttonClass!: string;

    @Prop() events!: Array<EventResponse>;

    loading = false;

    inviteError!: ApiError | null;

    inviteSection = true;

    inputEmail = '';

    failed = false;

    setError!: (error: ApiError | null) => void;

    invite!: (Invite: InviteRequest) => Promise<void>;

    getAllProjectUsers!: (id: number) => Promise<void>;

    close(): void {
        this.setError(null);
        this.failed = false;
    }

    onSubmit(request: InviteInformation): void {
        this.loading = true;
        this.inputEmail = request.email;
        this.invite({
            projectId: this.id,
            email: request.email,
            eventIds: request.eventIds,
        })
            .then(() => {
                this.inviteSection = false;
                this.getAllProjectUsers(Number(this.id));
                this.showToast(
                    this.$t('invite.success').toString(),
                    this.$t('success-title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                this.failed = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
